module.exports = require('./internal/FixedDataTableRoot');



/*****************
 ** WEBPACK FOOTER
 ** ./~/fixed-data-table/main.js
 ** module id = 663
 ** module chunks = 10
 **/